import axios from 'axios'
import { GET_ERRORS, GET_OBJECT, GET_OBJECTS, OBJECTS_LOADING, RESET_QLIK_STATE } from './types'
import { ToastsStore } from 'react-toasts'
import { resetErrors } from './errorsActions'
//GET OBJECTS
export const getObjects = page_id => dispatch => {
  dispatch(setObjectsLoading())
  dispatch(resetErrors)
  axios
    .get(`/api/pages/objects/${page_id}`)
    .then(res => {
      dispatch({
        type: GET_OBJECTS,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({ type: GET_ERRORS, payload: err.response.data })
    })
}

//GET OBJECT
export const getObject = (page_id, object_id) => dispatch => {
  dispatch(setObjectsLoading())
  dispatch(resetErrors)

  axios
    .get(`/api/pages/objects/${page_id}/${object_id}`)
    .then(res => {
      dispatch({
        type: GET_OBJECT,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({ type: RESET_QLIK_STATE })
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    })
}

//CREATE OBJECT
export const createObject = (page_id, objectData, history) => dispatch => {
  dispatch(resetErrors)

  axios
    .post(`/api/pages/objects/${page_id}`, objectData)
    .then(res => {
      ToastsStore.success(`Object Created successfully`)

      history.push(`/settings/pages/${page_id}/view`)
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    })
}

export const deleteObject = (page, object) => dispatch => {
  dispatch(resetErrors)

  axios
    .delete(`/api/pages/objects/${page}/${object}`)
    .then(res => {
      dispatch(getObjects(page))
      window.location.reload()
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
      ToastsStore.error('Error deleting object')
    })
}

// EDIT OBJECT
export const editObject = (page_id, object_id, objectData, history) => dispatch => {
  dispatch(resetErrors)

  axios
    .post(`/api/pages/objects/${page_id}/${object_id}`, objectData)
    .then(res => {
      ToastsStore.success(`Object updated successfully`)
      history.push(`/settings/pages/${page_id}/view`)
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    })
}

export const resetObjects = () => {
  return {
    type: RESET_QLIK_STATE,
  }
}

export const setObjectsLoading = () => {
  return {
    type: OBJECTS_LOADING,
  }
}
